import React from 'react';
import {WalletType} from '../utils/useActiveTab';
import {CoinsSkeletons} from './CoinsSkeletons';
import {CouponSkeletons} from './CouponSkeletons';
import {NotificationCenterSkeletons} from './NotificationCenterSkeletons';

export const WalletContentSkeletons: React.FC<{activeTab: WalletType}> = ({
  activeTab,
}) => {
  switch (activeTab) {
    case 'coins':
      return <CoinsSkeletons />;
    case 'coupons':
      return <CouponSkeletons />;
    case 'notificationCenter':
      return <NotificationCenterSkeletons />;
    default:
      return null;
  }
};
